<button
    *ngIf="variant === 'filled'"
    fcp-filled-button
    [disabled]="disabled"
    [color]="color"
    [iconOnly]="iconOnly"
    [cdkMenuTriggerFor]="menu"
    [cdkMenuPosition]="menuPosition"
    (cdkMenuClosed)="onCdkMenuClosed()"
    (cdkMenuOpened)="onCdkMenuOpened()"
>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</button>
<button
    *ngIf="variant === 'outlined'"
    fcp-outlined-button
    [disabled]="disabled"
    [color]="color"
    [iconOnly]="iconOnly"
    [cdkMenuTriggerFor]="menu"
    [cdkMenuPosition]="menuPosition"
    (click)="onMenuClicked($event)"
    (cdkMenuClosed)="onCdkMenuClosed()"
    (cdkMenuOpened)="onCdkMenuOpened()"
>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</button>
<ng-template #contentTemplate><ng-content></ng-content></ng-template>

<ng-template #menu>
    <div
        class="fcp-menu"
        [ngClass]="{ 'fcp-menu--prominent': menuStyle === 'prominent', 'fcp-menu--subtle': menuStyle === 'subtle' }"
        cdkMenu
    >
        <button
            *ngFor="let item of list; let idx = index"
            class="fcp-menu-item"
            [ngClass]="{
                'fcp-menu-item--disabled': item.disabled,
                'fcp-menu-item-l fcp-text-button-l': menuSize === 'large',
                'fcp-menu-item-m fcp-text-button-m': menuSize === 'medium',
                'fcp-menu-item--separator': item.separator
            }"
            [disabled]="item.disabled"
            cdkMenuItem
            (cdkMenuItemTriggered)="onMenuItemTriggered(item, idx)"
            [cdkMenuItemDisabled]="item.disabled"
        >
            <div class="fcp-menu-item-content">
                <fcp-icon-svg
                    *ngIf="item.icon && item.icon.position === 'left'"
                    [icon]="item.icon?.name"
                    [color]="item.icon?.color"
                    [size]="item.icon?.size"
                ></fcp-icon-svg>
                <div>
                    <span class="fcp-menu-item-text">{{ item.text }}</span>
                    <span *ngIf="item.subtext" class="fcp-menu-item-subtext">{{ item.subtext }}</span>
                </div>
                <fcp-icon-svg
                    *ngIf="item.icon && item.icon.position === 'right'"
                    [icon]="item.icon?.name"
                    [color]="item.icon?.color"
                    [size]="item.icon?.size"
                ></fcp-icon-svg>
            </div>
        </button>
    </div>
</ng-template>
